interface QuestionCategoryData {
  id?: number;
  name?: string;
  color?: string;
  translations?: any;
}

export class QuestionCategory {
  public static getNonTranslatableFields(): string[] { return ['id', 'color']; }
  public static getTranslatableFields(): string[] { return ['name']; }
  public static getFields(): string[] { return ['id', 'name', 'color']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  name?: string;
  color?: string;
  translations?: any;


  public static fromAPI(data: QuestionCategoryData): QuestionCategory {
    let translationData: any = {};
    if (data.translations) {
      for (let i = 0; i < data.translations?.length; i++) {
        if (data.translations[i]['questionCategoryId'] === data['id']) {
          translationData = data.translations[i];
          i = data.translations?.length;
        }
      }
    }
    return new QuestionCategory({
      id: data.id,
      name: translationData.name ?? data.name,
      color: data.color,
      translations: data.translations
    });
  }

  public static fromAPIList(data: QuestionCategoryData[]): QuestionCategory[] {
    return data.map((item: QuestionCategoryData) => QuestionCategory.fromAPI(item));
  }


  constructor({id, name, color, translations}: QuestionCategoryData) {
    this.id = id;
    this.name = name;
    this.color = color;
    this.translations = translations;
  }

  public toJson(): QuestionCategoryData {
    return  {
      id: this.id,
      name: this.name,
      color: this.color
    };
  }

}
